import { LogoutOutlined } from "@ant-design/icons";
import { Button, Space, Tag, Typography } from "antd";
import { useNavigate } from "react-router";

import { useCatalog } from "../api/catalog";
import { GROUP_NAMES, ROLE_NAMES } from "../api/types";
import { useAuthenticated, useSession } from "../auth/SessionProvider";

/** Who is logged in, as which role, over which data. Shown on every authenticated page. */
export function UserBar() {
  const { principal } = useAuthenticated();
  const { logout } = useSession();
  const navigate = useNavigate();
  const catalog = useCatalog();
  const regionName = (id: number) => catalog.data?.regions.find((region) => region.id === id)?.name ?? `区域 ${id}`;
  const siteName = (id: number) => catalog.data?.sites.find((site) => site.id === id)?.name ?? `考点 ${id}`;
  const groupTags = principal.scope.groups === "all"
    ? [<Tag key="all-groups">全部组别</Tag>]
    : principal.scope.groups.map((group) => <Tag key={group}>{GROUP_NAMES[group]}</Tag>);
  const regionTags = principal.scope.regions === "all"
    ? [<Tag key="all-regions">全部区域</Tag>]
    : principal.scope.regions.map((id) => <Tag key={id}>{regionName(id)}</Tag>);
  const siteTags = principal.scope.sites === "all" ? [] : principal.scope.sites.map((id) => <Tag key={`s${id}`} color="geekblue">{siteName(id)}</Tag>);
  return (
    <Space size="middle" wrap>
      <Typography.Text strong>{principal.displayName}</Typography.Text>
      <Tag color="blue">{ROLE_NAMES[principal.role]}</Tag>
      <span className="scope-tags">{groupTags}{regionTags}{siteTags}</span>
      <Button
        icon={<LogoutOutlined />}
        onClick={() => {
          void logout().then(() => navigate("/login", { replace: true }));
        }}
      >
        退出登录
      </Button>
    </Space>
  );
}
